import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import Button from "../../elements/CustomButton/CustomButton.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import UserService from "../../services/UserService";
import { mountTable, unmountTable, getTable } from '../Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';

const dataTable = {
  headerRow: ["Id", "Nombre y Apellido", "Email", "Rol", "Acciones"],
  footerRow: ["Id", "Nombre y Apellido", "Email", "Rol", "Acciones"]
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.successDelete = this.successDelete.bind(this);
    this.warningWithConfirmMessage = this.warningWithConfirmMessage.bind(this);
    this.userService = new UserService();
  }
  warningWithConfirmMessage(user) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Borrar"
          onConfirm={() => this.successDelete(user)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí, bórralo!"
          cancelBtnText="Cancelar"
          showCancel
        >
          ¿Esta seguro de borrar el usuario "{user[1]}"?
        </SweetAlert>
      )
    });
  }
  successDelete(user) {
    const table = getTable("users");
    this.userService
      .deleteUser(user[0])
      .then(res => {
        // todo ok muestro el mensaje y recargo la tabla
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Deleted!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              El usuario "{user[1]}" ha sido borrado
            </SweetAlert>
          )
        });
        // recarga la tabla
        table.clear();
        //table.ajax.reload();
        table.draw();
      })
      .catch(err => {
        console.log(err);
        alert(err);
      });

  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  editTable(data) {
      window.location = "/#/users-management/edit/" + data[0];
  }
  componentDidMount() {
    mountTable(API_ROOT + "/users", "users", this.editTable, this.warningWithConfirmMessage);
  }
  componentWillUnmount() {
    unmountTable('users');
  }
  shouldComponentUpdate() {
    return true;
  }
  addUser() {
    this.props.history.push("/users-management/create");
  }
  render() {
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                title="Usuarios del sistema"
                content={
                  <div className="fresh-datatables">
                    <div
                      style={{ paddingBottom: 10 + "px", textAlign: "right" }}
                    >
                      <Button
                        bsStyle="primary"
                        bsSize="sm"
                        fill
                        wd
                        onClick={this.addUser.bind(this)}
                      >
                        Nuevo
                      </Button>
                    </div>
                    <JQueryTableComponent identifier="users" dataTable={dataTable} />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/views/UsersManagement/Main.jsx